import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as NuacomComponent from '~/components';
import * as lib from '~/dependencies';
import { eventTracker } from '~/helpers';
import {
  clearHistoryCustomFilters,
  setOpenEnhancedSearch,
} from '~/store/actions/call';
import TabCallLogs from './components/Tab';
import ExpandableHistoryCustomFilters from './components/ExpandableHistoryCustomFilters';
import { PhoneContainer, ContainerHistory } from './styles';

export default function Phone(props) {
  const dispatch = useDispatch();
  const { colapseFindInput } = props;

  const [tab, setTab] = useState(0);
  const [openSimpleSearchBox, setOpenSimpleSearchBox] = useState(false);

  // SELECTORS
  const openEnhancedSearch = useSelector(
    state => state.call.openEnhancedSearch
  );

  useEffect(() => {
    colapseFindInput(false);
  }, [colapseFindInput]);

  useEffect(() => {
    return () => {
      dispatch(clearHistoryCustomFilters());
    };
  }, [dispatch]);

  function handleCallLogsSearchOnClose() {
    setOpenSimpleSearchBox(false);
    dispatch(setOpenEnhancedSearch(!openEnhancedSearch));
    dispatch(clearHistoryCustomFilters());
  }

  function handleFilterMenu(value) {
    setOpenSimpleSearchBox(value);
    dispatch(setOpenEnhancedSearch(!openEnhancedSearch));
    eventTracker(events => events.CallHistorySearchClicked);
  }

  function renderSearchComponents() {
    if (openSimpleSearchBox) {
      return (
        <>
          <NuacomComponent.CallLogsSearch
            onClose={handleCallLogsSearchOnClose}
          />
        </>
      );
    }

    return (
      <>
        <TabCallLogs setTab={setTab} tab={tab} />
        <NuacomComponent.BtnSearch
          callback={handleFilterMenu}
          value={openSimpleSearchBox}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: 10,
          }}>
          {/* <TuneIcon
            color="primary"
            onClick={() => setOpenOptionsSearchBox(true)}
          /> */}
        </div>
      </>
    );
  }

  return (
    <>
      <NuacomComponent.Header {...props}>
        {renderSearchComponents()}
      </NuacomComponent.Header>

      {openSimpleSearchBox && openEnhancedSearch && (
        <ExpandableHistoryCustomFilters expanded={openEnhancedSearch} />
      )}

      <PhoneContainer>
        <ContainerHistory>
          <NuacomComponent.CallHistory tab={tab} />
        </ContainerHistory>
      </PhoneContainer>
    </>
  );
}

Phone.defaultProps = {
  colapseFindInput: () => {},
};

Phone.propTypes = {
  colapseFindInput: lib.PropTypes.func,
};
